module.exports = __webpack_public_path__ + "img/bg.43cafea6.png";